import { Database } from "@/lib/supabase/types";
import { User } from "@supabase/supabase-js";
import { createContext, useContext } from "react";

export type UserProfile = Database["public"]["Tables"]["profiles"]["Row"];
export type UserPermission = Database["public"]["Enums"]["app_permission"];

export type UserContextType = {
    user: User;
    profile: UserProfile;
    updateProfile: (patch: Partial<UserProfile>) => Promise<boolean>;
    role: Database["public"]["Enums"]["app_role"];
    permissions: Set<UserPermission>;
    authReady: boolean;
    permissionsReady: boolean;
    logout: () => void;
};

const UserContext = createContext<UserContextType | undefined>(undefined);
export const UserContextProvider = UserContext.Provider;

export function useUserContext() {
    const ctx = useContext(UserContext);
    if (!ctx) throw new Error("useUserContext must be used within a <UserProvider />");
    return ctx;
}